const BASE_URL = process.env.VUE_APP_BASE_URL != "" ? process.env.VUE_APP_BASE_URL : "";

const API_URL = `${BASE_URL}/api`;
export default Object.freeze({
	BASE_URL,
	API_URL,
	TOKEN_REFRESH_INTERVAL: Number(process.env.VUE_APP_TOKEN_REFRESH_INTERVAL)
});
